import IBAN from 'iban';
import { isEmpty, ValidationResult } from './getValidator';

const getIbanValidator =
  () =>
  (value: string): ValidationResult => {
    if (isEmpty(value)) {
      return { key: 'required' };
    } else if (!IBAN.isValid(value)) {
      return { key: 'invalid' };
    } else {
      return undefined;
    }
  };

export default getIbanValidator;
